import {calcDiscount} from "../utils/payment";

export default context => {

    const container = $('.tickets-tickets', context)
    if (container.length === 0) {
        return
    }
    let counter = 0;

    const $form = $(container).find('.tickets-form')
    const appendTemplate = () => $(container.find('template').html().replaceAll('{new}', 'new_' + counter++))
        //.find().addBack().filter() mean "find including in the root node"
        .find('.ticket-form-item').addBack().filter('.ticket-form-item').addClass('editable')
        .prevObject.appendTo($form)


    container.find('button[data-action="add-paid"]').on('click', function () {
        appendTemplate().addClass('paid-ticket')
        container.closest('.tickets-wrapper').trigger('coing.ticket.added', {type: 'paid'})
        return false
    })
    container.find('button[data-action="add-free"]').on('click', function () {
        appendTemplate().addClass('free-ticket')
        container.closest('.tickets-wrapper').trigger('coing.ticket.added', {type: 'free'})
        return false
    })
    container.find('button[data-action="add-donation"]').on('click', function () {
        appendTemplate().addClass('donation-ticket').find('input.custom-price').val('1')
        container.closest('.tickets-wrapper').trigger('coing.ticket.added', {type: 'donation'})
        return false
    })
    container.on('click', '[data-action="delete-item"]', function () {
        $(this).closest('.ticket-info').find('input[type=checkbox][name$="[is_enabled]"]')
            .prop('checked', false)
            .trigger('change')
        return false
    })
    container.on('click', '[data-action="restore-item"]', function () {
        $(this).closest('.ticket-info').find('input[type=checkbox][name$="[is_enabled]"]')
            .prop('checked', true)
            .trigger('change')
        return false
    })
    container.on('click', '[data-action="edit-item"]', function () {
        $(this).closest('.ticket-form-item').addClass('editable')
        return false
    })
    container.on('click', '.item-switch', function () {
        $(this).closest('.ticket-form-item').toggleClass('editable')
    })
    container.on('change', '.ticket-info input[type=checkbox][name$="[is_enabled]"]', function () {
        if ($(this).is(':checked')) {
            $(this).closest('.ticket-form-item').removeClass('disabled')
        } else {
            $(this).closest('.ticket-form-item').addClass('disabled')
        }
        container.closest('.tickets-wrapper').trigger('coing.ticket.enabled', $(this).is(':checked'))
    })
    container.on('change', '.discount-select', function () {
        const $this = $(this)
        const textContainer = $this.closest('tr').find('.calculated-discount')
        const discountStr = $this.val()
        const price = parseInt($this.closest('tbody').find('.ticket-info [data-name="price"] input').val()) || 0
        if (price === 0 || !discountStr) {
            textContainer.text('')
            return
        }
        const discount = discountStr.split('-')
        textContainer.text(calcDiscount(price, discount[1], discount[2], false))
    })
    container.on('change', '[data-name="price"] input', function () {
        $(this).closest('tbody').find('tr.segment-info [data-name="discount"] select').trigger('change')
    })
    container.on('change', 'input', function () {
        const $this = $(this)
        $this.closest('[data-name]').find('.value-container').text($this.val())
    })
    $form.find('input:not([type="hidden"])').trigger('change')

    container.on('change', '.segment-info [data-name="is_enabled"] input[type="checkbox"]', function () {
        if ($(this).is(':checked')) {
            $(this).closest('.segment-info').removeClass('inactive')
        } else {
            $(this).closest('.segment-info').addClass('inactive')
        }
    })
    container.on('change', '.donation-ticket .ticket-info [data-name=is_minimal_price] input[type=checkbox]', function() {
        const row = $(this).closest('.ticket-info')
        if ($(this).is(':checked')) {
            row.find('[data-name=price] input').attr('readonly', false)
            row.siblings('.info.for-donation').hide()
        } else {
            row.find('[data-name=price] input').attr('readonly', true).val('')
            row.siblings('.info.for-donation').show()
        }
    })

    const sortTickets = function () {
        const form = $('.tickets-tickets .tickets-form', context)
        $('#TicketsOverviewList [data-id]', context).each(function () {
            const id = $(this).data('id')
            form.find(`.ticket-form-item[data-id=${id}]`).appendTo(form)
        })
    }

    const validateTickets = function (e) {
        const form = $('.tickets-tickets .tickets-form', context)
        form.find('.required input:visible').each(function () {
            if (!$(this).val()) {
                e.preventDefault();
                $(this).closest('.form-group').addClass('has-error')
            } else {
                $(this).closest('.form-group').removeClass('has-error')
            }
        })
    }

    const overrideNextButton = function () {
        const footer = container.closest('.modal-content').find('.modal-footer')
        if (footer.find('.btn-overview').length === 0) {
            const btnSave = footer.find('.btn-save')
            const btnNext = footer.find('.btn-send').css('display', 'none')
            const btnOverview = $(`<button type="button" class="btn btn-main btn-overview"></button>`)
                .text(btnNext.text())
                .on('click', () => $('.tabbed-content nav a[href="#overview"]', context).trigger("click"))
            $('section[data-tab="overview"]', context).one('shown.coing.tabs', () => {
                footer.find('.btn-overview').remove()
                btnNext.css('display', '')
            })
            btnNext.after(btnOverview)
        }
    }

    const modal = $(context).closest('.modal')
    if (modal.hasClass('steps')) {
        const section = container.closest('.form-group').data('section')
        modal.on('coing.steps.changed', function (e, activeSection) {
            if (activeSection === section) {
                $('section[data-tab="tickets"]', context).on('shown.coing.tabs.nextbtn', overrideNextButton)
                $('section[data-tab="memberships"]', context).on('shown.coing.tabs.nextbtn', overrideNextButton)
                if ($('section[data-tab="tickets"]:visible,section[data-tab="memberships"]:visible').length > 0) {
                    overrideNextButton()
                }
            } else {
                $('section[data-tab="tickets"]', context).off('shown.coing.tabs.nextbtn')
                $('section[data-tab="memberships"]', context).off('shown.coing.tabs.nextbtn')
            }
        })
    } else {
        $('section[data-tab="tickets"]', context).on('shown.coing.tabs', overrideNextButton)
        $('section[data-tab="memberships"]', context).on('shown.coing.tabs', overrideNextButton)
    }

    const updateOverviewTickets = function () {
        const table = $('#TicketsOverviewList', context).html('')
        const template = $($(table).data('template'), context).html()
        const source = $('table.tickets-form', context)
        // if ($('.tickets-wrapper nav a[href="#tickets"]', context).hasClass('disabled')) {
        // return
        // }
        let sort = 1;
        source.find('.ticket-form-item').each(function () {
            let row = template;
            ['name', 'description', 'price', 'quota'].forEach(e => {
                row = row.replaceAll(`{${e}}`, $(this).find(`.ticket-info [data-name="${e}"] .value-container`).text())
            })
            row = row
                .replaceAll('{id}', $(this).find('.ticket-info input.id').val())
                .replaceAll('{sort}', sort++)
                .replaceAll(
                    '{discount}',
                    $(this).find('.segment-info [data-name=is_enabled] input:checkbox:checked').length > 0
                        ? '<svg><title>Yes</title><use xlink:href="#icon-checkmark"></use></svg>'
                        : ''
                )
            row = $(row)
            if ($(this).hasClass('disabled')) {
                row.addClass('disabled')
            }
            // Workaround for edit group pagination process.
            // Disables fields on hidden pages.
            if ($(this).find('.ticket-info [data-name] input').prop('disabled')) {
                row.find('input').prop('disabled', true)
            }
            table.append(row)
        })
    }

    $('section[data-tab="overview"]', context).on('shown.coing.tabs', updateOverviewTickets)
    $('section[data-tab="tickets"]', context)
        .on('shown.coing.tabs', sortTickets)
        .on('hide.coing.tabs', validateTickets)
    $('.tickets-wrapper nav', context).on('state-changed.coing', updateOverviewTickets)
    $('.tickets-wrapper', context).on('coing.ticket.added', function() {
        container.find('.ticket-info [data-name=is_minimal_price] input[type=checkbox]').trigger('change')
    })
    container.find('.ticket-info [data-name=is_minimal_price] input[type=checkbox]').trigger('change')

}
